<script setup lang="ts">
    import type { AiMessage } from '~/stores/aiAssistantTypes';
    import { useAuthStore } from '~/stores/authStore';

    const authStore = useAuthStore();

    defineProps<{
        message: AiMessage;
    }>();

    const formattedTime = (d: Date) =>
        `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
</script>

<template>
    <div class="flex flex-col gap-[5px] items-end px-[15px] py-[5px] w-full">
        <div class="flex gap-[6px] items-end max-w-[680px] w-full">
            <div class="flex-1 min-w-0 bg-gray-100 px-[15px] py-[10px] rounded-tl-[10px] rounded-tr-[10px] rounded-bl-[10px] rounded-br-[5px]">
                <div class="flex items-center gap-[10px]">
                    <img
                        v-if="message.fileInfo?.thumbnail"
                        :src="message.fileInfo.thumbnail"
                        :alt="message.fileInfo?.name"
                        class="w-[40px] h-[40px] rounded-[6px] object-cover shrink-0"
                    />
                    <div
                        v-else
                        class="w-[40px] h-[40px] rounded-[6px] bg-gray-200 flex items-center justify-center shrink-0"
                    >
                        <i class="fa-regular fa-file text-[16px] text-gray-500"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-[12px] leading-[16px] text-gray-800 truncate">
                            {{ message.fileInfo?.name }}
                        </p>
                        <p class="text-[10px] text-gray-400">
                            {{ message.content }}
                        </p>
                    </div>
                </div>
            </div>
            <AuthUserAvatar
                :user="authStore.authed"
                size="w-[22px] h-[22px]"
                :clickable-avatar="false"
            />
        </div>
        <div class="flex gap-[6px] items-start">
            <span class="text-[10px] text-[#abb5c0]">{{ formattedTime(message.timestamp) }}</span>
        </div>
    </div>
</template>
